export default __webpack_public_path__ + "static/media/empowered-logo.ecfc263f.png";